import { Cell, Pie, PieChart, ResponsiveContainer, Tooltip } from 'recharts';
import AcademiaToolTip from './AcademiaToolTip';

interface IAcademiaPieChart {
  data: Array<any>;
  total: number;
  totalLabel?: string;
  colors: Array<string>;
}

const AcademiaPieChart = ({
  data,
  total,
  totalLabel,
  colors,
}: IAcademiaPieChart) => {
  // rendering custom pie chart component here
  return (
    <div className='relative h-[300px] w-full'>
      <ResponsiveContainer className={'relative'} width='100%' height='100%'>
        <PieChart className='flex-1 w-full'>
          <Pie
            data={data}
            cx='50%'
            cy='50%'
            innerRadius={120}
            outerRadius={150}
            fill='#8884d8'
            paddingAngle={3}
            dataKey='value'
          >
            {data?.map((entry, index) => (
              <Cell
                key={`cell-${index}`}
                fill={colors[index % colors.length]}
              />
            ))}
          </Pie>
          <Tooltip
            content={<AcademiaToolTip active={undefined} payload={undefined} />}
          />
        </PieChart>
      </ResponsiveContainer>

      <div className='absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 text-center'>
        <p className='text-gray-300'>{totalLabel ? totalLabel : 'Total'}</p>
        <h3 className='text-2xl font-semibold text-base-light-blue'>{total}</h3>
      </div>
    </div>
  );
};

export default AcademiaPieChart;
